import { Component } from '@angular/core';

@Component({
  selector: 'op-settings-page',
  template: `
    <section class="settings-page">
      <div class="page-header">
        <h1>Settings</h1>
      </div>

      <div class="settings-card">
        <span>Empty for now.</span>
      </div>
    </section>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      .page-header {
        margin-bottom: 20px;
      }
      h1 {
        margin: 0;
        color: #25364a;
        font-size: 34px;
        font-weight: 700;
      }
      .settings-card {
        display: grid;
        place-items: center;
        min-height: 280px;
        border: 1px dashed #d6deea;
        border-radius: 14px;
        background: rgba(255, 255, 255, 0.72);
        color: #6c7a89;
        font-size: 14px;
      }
      @media (max-width: 900px) {
        h1 {
          font-size: 30px;
        }
      }
    `,
  ],
})
export class SettingsPage {}
